import { Component, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Component({
  selector: "app-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.scss"],
})
export class ServicesComponent implements OnInit {
  constructor(private Fire: AngularFirestore) {}
  services: any = [];
  ngOnInit(): void {
    this.getServices();
  }

  getServices() {
    this.Fire.collection("Services")
      .valueChanges()
      .subscribe(
        (res) => {
          this.services = res;
        },
        (err) => {}
      );
  }
}
